//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GoogleAds',
  props: {
    dataAdClient: {
      type: String,
      required: true,
    },
    dataAdSlot: {
      type: [String, Number],
      required: true,
    },
  },
  mounted() {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdsbyGoogle push error:', e);
    }
  },
};
